import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data);
        window.history.replaceState({}, "", window.location.pathname);
        navigate(data.is_admin ? "/admin" : "/account", { replace: true });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center text-amber-400 tracking-widest">
      Signing you in…
    </div>
  );
}
